import React  from "react";
import CircularProgress from '@material-ui/core/CircularProgress';
import {useSelector} from "react-redux";
import {getLoadingState, getLoadingText} from "../reducks/loading/selectors";

const Loading = ({children}) => {
    const selector = useSelector((state) => state);
    const isBeingLoaded = getLoadingState(selector);
    const loadingText  = getLoadingText(selector);

    const loadingEntireStyle = {
        "alignItems":"center",
        "background":"rgba(255, 255, 255, 0.7)",
        "display":"flex",
        "flexFlow":"column",
        "justifyContent":"center",
        "opacity":"0.9",
        "position":"fixed",
        "top":"0","left":"0",
        "height":"100vh",
        "width":"100%",
        "zIndex":"9999"
    }
    const loadingStrStyle = {
        "color":"#444",
        "fontWeight":"600",
        "marginTop":"1rem",
        "textAlign":"center"
    }

    return (
        <div>
            {(isBeingLoaded) && (
                <section style={loadingEntireStyle}>
                    <CircularProgress/>
                    <p style={loadingStrStyle}>{loadingText}</p>
                </section>
            )}
            {children}
        </div>
    );
};

export default Loading